import { Link } from "react-router-dom";
import { footerContact, footerItem, socialIcons } from "../../data/Data";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <>
      <div className="bg-gray-50 shadow-lg text-primary py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-8">
            {/* Hotelier Section */}
            <div className="p-6 rounded-lg flex flex-col gap-3">
              <Link to="/home">
                <img src={logo} className="h-14 w-full" alt="Gold Palace Inn Logo" />
              </Link>
            </div>

            {/* Contact Section */}
            <div>
              <h6 className="text-lg font-itim font-bold text-primary uppercase mb-2 relative">
                Contact
                <span className="block w-10 h-0.5 bg-primary mt-1"></span>
              </h6>
              {footerContact.map((val, index) => (
                <p className="mb-2 flex items-center text-sm" key={index}>
                  {val.icon} <span className="ml-2 font-k2d">{val.name}</span>
                </p>
              ))}
              <div className="flex space-x-2 text-primary mt-4">
                {socialIcons.map((val, index) => (
                  <Link
                    className="p-3 border border-gray-700 rounded-full hover:bg-yellow-500 font-k2d hover:text-white transition duration-300"
                    to={val.link}
                    key={index}
                  >
                    {val.icon}
                  </Link>
                ))}
              </div>
            </div>

            {footerItem.map((section) => (
              <div key={section.id}>
                <h6 className="text-lg text-primary font-itim font-bold uppercase mb-2 relative">
                  {section.header}
                  <span className="block w-10 h-0.5 bg-primary mt-1"></span>
                </h6>
                {section.UnitItem.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    className="block mb-2 font-k2d text-sm hover:text-primary transition duration-300"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
